import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BreadcrumbResolver } from './catalog-services/breadcrumb/breadcrumb.resolver';
import { CatalogRedirectComponent } from './catalog-components/catalog-redirect.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'configuration',
        data: {
          breadcrumbs: 'Konfiguration',
        },
        loadChildren: () =>
          import('./catalog-features/steel-configuration/steel-configuration.module').then((m) => m.SteelConfigurationModule),
      },
      {
        path: 'product/:id',
        data: {
          breadcrumbs: BreadcrumbResolver,
        },
        loadChildren: () => import('./catalog-features/product/product.module').then((m) => m.ProductModule),
      },
      {
        path: 'article/:id',
        data: {
          breadcrumbs: BreadcrumbResolver,
        },
        loadChildren: () => import('./catalog-features/article/article.module').then((m) => m.ArticleModule),
      },
      // {
      //   path: 'search',
      //   data: {
      //     breadcrumbs: 'Suchresultate',
      //   },
      //   loadChildren: () => import('./catalog-features/search-result/search-result.module').then((m) => m.SearchResultModule),
      // },
      {
        path: 'category-filter/:id',
        data: {
          breadcrumbs: BreadcrumbResolver,
        },
        loadChildren: () => import('./catalog-features/category-filter/category-filter.module').then((m) => m.CategoryFilterModule),
      },
      {
        path: 'search',
        data: {
          breadcrumbs: BreadcrumbResolver,
        },
        loadChildren: () => import('./catalog-features/search-result/search-result.module').then((m) => m.SearchResultModule),
      },
      {
        path: '**',
        component: CatalogRedirectComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CatalogRoutingModule {}
